// A Font Awesome name not registered here draws nothing; utils/icons.guard.spec.ts fails it.
import { library, type IconDefinition } from "@fortawesome/fontawesome-svg-core";
import * as kitMarks from "@awesome.me/kit-698d8619ec/icons/kit/custom";

import {
  faAndroid,
  faApple,
  faAws,
  faChrome,
  faCloud,
  faCloudflare,
  faDigitalOcean,
  faEdge,
  faFirefoxBrowser,
  faFreebsd,
  faGear,
  faGlobe,
  faGoogle,
  faInternetExplorer,
  faKey,
  faLinux,
  faMicrosoft,
  faOpera,
  faSafari,
  faServer,
  faShieldHalved,
  faTerminal,
  faWindows,
} from "./brandIconData";

export const BRAND_MARKS: IconDefinition[] = [
  faAndroid,
  faApple,
  faAws,
  faChrome,
  faCloudflare,
  faDigitalOcean,
  faEdge,
  faFirefoxBrowser,
  faFreebsd,
  faGoogle,
  faInternetExplorer,
  faLinux,
  faMicrosoft,
  faOpera,
  faSafari,
  faWindows,
  ...(Object.values(kitMarks) as IconDefinition[]),
  faCloud,
  faGear,
  faGlobe,
  faKey,
  faServer,
  faShieldHalved,
  faTerminal,
] as IconDefinition[];

export function registerBrandIcons(): void {
  library.add(...BRAND_MARKS);
}
